import React from "react";

const services = [
  {
    title: "Product Development",
    description: [
      "New product development using cutting-edge technology",
      "Fast and continuous releases",
      "Compatible with all major operating systems"
    ]
  },
  {
    title: "Product Maintenance",
    description: [
      "Clearly defined SLA",
      "Trusted maintenance partner",
      "Easy to test with a package starting from 100 hours of support"
    ]
  },
  {
    title: "IT Staffing",
    description: [
      "Ready resources rich in experience",
      "Good technology stack",
      "Quick onboarding"
    ]
  },
  {
    title: "Training",
    description: [
      "Job-oriented training for college students",
      "Opportunity to work on live projects",
      "Opportunity for a paid internship"
    ]
  }
];

export default function Services() {
  return (
    <section id="services" className="py-20 px-6 bg-gray-500">
      <h2 className="text-4xl font-bold text-center text-white mb-5">Our Services</h2>
      <p className="text-2xl text-center text-white mb-10">Comprehensive consulting solutions for transforming your business and accelarating your path to success.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 max-w-7xl mx-auto">
        {services.map((s, i) => (
          <div key={i} className="bg-gray-700 p-8 rounded-2xl shadow-xl hover:shadow-2xl transition">
            <h3 className="text-2xl font-semibold text-green-500 mb-4">
              {s.title}
            </h3>
            <p className="text-white text-md leading-relaxed">
              {s.description.map((line, index) => (
                <li key={index}>{line}</li>
              ))}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
